import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getListCodeCountry = (params) => {
    return axios.get(`${backendHost}/api/admin/code_country`, {params});
};